import { Logger, sharedRef } from '@vue-storefront/core';
import { computed } from '@nuxtjs/composition-api';
import { errorToString } from '~/helpers/error/errorToString';
import { ApiParams, ShippingProviderState } from '~/types/commercetools';
import { useCart } from '~/utils/ct/composables/useCart';

export function useShippingProvider() {
  const { cart, load: loadCart } = useCart();

  const loading = sharedRef<boolean>(false, 'useShippingProvider-loading');
  const state = sharedRef<ShippingProviderState | null>(null, 'useShippingProvider-shipping');
  const error = sharedRef<{
    load: string | null,
  }>({
    load: null,
  }, 'useShippingProvider-error');

  async function load({ customQuery }: ApiParams = {}) {
    Logger.debug('useShippingProvider.load');
    try {
      loading.value = true;
      if (!cart.value?.shippingInfo) {
        await loadCart({ customQuery });
      }

      error.value.load = null;
      if (cart.value?.shippingInfo) {
        state.value = {
          response: cart.value.shippingInfo,
        };
      } else {
        state.value = null;
      }
    } catch (err) {
      error.value.load = errorToString(err);
      Logger.error('useShippingProvider/load', err);
    } finally {
      loading.value = false;
    }
  }
  return {
    state: computed(() => state.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value),
    load,
  };
}
